import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7524432d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-page ha-page" }
const _hoisted_2 = { class: "ha-signin l-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "ha__ttl c-ttl" }, "ログイン", -1))
const _hoisted_4 = { class: "ha__sec ha-signin__sec" }
const _hoisted_5 = { class: "ha-signin__login" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ha-signin__ttl c-card__ttl" }, "集英社IDをお持ちの方", -1))
const _hoisted_7 = { class: "ha-signin__field-container" }
const _hoisted_8 = {
  key: 0,
  class: "ha-errors"
}
const _hoisted_9 = { class: "c-error" }
const _hoisted_10 = { class: "p-fields" }
const _hoisted_11 = { class: "c-field" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "username"
}, [
  /*#__PURE__*/_createTextVNode("集英社ID"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("（メールアドレス）")
], -1))
const _hoisted_13 = { class: "c-field__body" }
const _hoisted_14 = { class: "c-field__input" }
const _hoisted_15 = { class: "c-field" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "password"
}, "パスワード", -1))
const _hoisted_17 = { class: "c-field__body" }
const _hoisted_18 = { class: "c-field__input" }
const _hoisted_19 = ["type", "maxlength"]
const _hoisted_20 = { class: "c-field has-mt" }
const _hoisted_21 = { class: "c-field__auto-signin" }
const _hoisted_22 = {
  class: "c-field__checkbox",
  for: "auto-signin-off"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "自動ログインを無効にする", -1))
const _hoisted_24 = { class: "c-field has-submit" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ログイン", -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = { class: "ha-signin__resetpass has-link" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "パスワードを忘れた方", -1))
const _hoisted_30 = {
  key: 0,
  class: "p-messages"
}
const _hoisted_31 = { class: "c-message" }
const _hoisted_32 = { class: "c-message__txt c-message__txt--primary" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_34 = {
  key: 0,
  class: "c-message__txt c-message__txt--primary"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_36 = { style: {"flex-wrap":"wrap"} }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" お手数ですが")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("からサービス登録の後に再度ログインしてください。 ")
const _hoisted_39 = {
  key: 1,
  class: "p-messages"
}
const _hoisted_40 = { class: "c-message" }
const _hoisted_41 = { class: "c-message__txt c-message__txt--primary" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_43 = {
  key: 0,
  class: "c-message__txt c-message__txt--primary"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_45 = { style: {"flex-wrap":"wrap"} }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" お手数ですが")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("からメルマガ購読を許可いただいた後に再度ログインしてください。 ")
const _hoisted_48 = { class: "ha-signin__signup" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ha-signin__ttl c-card__ttl" }, "集英社IDをお持ちでない方", -1))
const _hoisted_50 = { class: "ha-signin__link r-container" }
const _hoisted_51 = ["disabled"]
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新規会員登録", -1))
const _hoisted_53 = [
  _hoisted_52
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.asyncDeterringWrap(_ctx.login, this)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              (_ctx.loginErrorMsgRef)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.loginErrorMsgRef), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("fieldset", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "username",
                        name: "username",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.emailRef) = $event)),
                        placeholder: "******@**.**.jp",
                        autocomplete: "email",
                        required: ""
                      }, null, 512), [
                        [_vModelText, _ctx.emailRef]
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _withDirectives(_createElementVNode("input", {
                        type: _ctx.passwordToggle.fieldType,
                        id: "password",
                        name: "password",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.passwordRef) = $event)),
                        maxlength: _ctx.PASSWORD_MAX_LENGTH,
                        placeholder: "英字大小文字、数字を含む8文字以上",
                        autocomplete: "current-password",
                        required: ""
                      }, null, 8, _hoisted_19), [
                        [_vModelDynamic, _ctx.passwordRef]
                      ]),
                      _createElementVNode("i", {
                        class: _normalizeClass(["pw-toggle", { 'is-on': _ctx.passwordToggle.isOn }]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchPasswordFieldType(_ctx.passwordToggle)))
                      }, null, 2)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("label", _hoisted_22, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        name: "auto-signin-off",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.disableAutoLoginRef) = $event)),
                        id: "auto-signin-off"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.disableAutoLoginRef]
                      ]),
                      _hoisted_23
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    class: "ha-btn is-submit",
                    disabled: !(_ctx.emailRef&&_ctx.passwordRef) || _ctx.isDeterringRef
                  }, _hoisted_27, 8, _hoisted_25)
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_router_link, {
                    to: { name: _ctx.routeNames.RESET_PASSWORD },
                    class: "c-link"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                (_ctx.isServiceNotRegErrorRef)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("p", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("span", null, "このアンケートへの参加には「" + _toDisplayString(_ctx.serviceName) + "」サービスへの登録が必要となります。", 1)
                        ]),
                        (!(_ctx.isApl || _ctx.isReal))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                              _hoisted_35,
                              _createElementVNode("span", _hoisted_36, [
                                _hoisted_37,
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToLinkageSite(_ctx.serviceLoginUrl as string, true))),
                                  class: "c-link c-link--primary"
                                }, "こちら"),
                                _hoisted_38
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isMmNotRegErrorRef)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("p", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("span", null, "このアンケートへの参加にはメールマガジン「" + _toDisplayString(_ctx.mailMagazineName) + "」の購読が必要となります。", 1)
                        ]),
                        (!(_ctx.isApl || _ctx.isReal))
                          ? (_openBlock(), _createElementBlock("p", _hoisted_43, [
                              _hoisted_44,
                              _createElementVNode("span", _hoisted_45, [
                                _hoisted_46,
                                _createElementVNode("a", {
                                  href: "javascript:void(0)",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.goToLinkageSite(_ctx.serviceUpdateAttrUrl as string, true))),
                                  class: "c-link c-link--primary"
                                }, "こちら"),
                                _hoisted_47
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _hoisted_49,
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("button", {
              type: "button",
              class: "ha-btn",
              disabled: _ctx.isDeterringRef,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToLinkageSite(_ctx.serviceRegUrl as string)))
            }, _hoisted_53, 8, _hoisted_51)
          ])
        ])
      ])
    ])
  ]))
}